import { useCallback, useRef } from 'react';
import {
    trackEvent,
    stepInteractionConstants,
    interactionTypeConstants,
    eventNameConstants,
    StepInteractionNameValues,
} from 'dibs-tracking';

export const useCondensedCircleContentTracking = ({
    vertical,
}: {
    vertical: string;
}): {
    handleSectionVisibilityChange: ({ isVisible }: { isVisible: boolean }) => void;
    handleCircleClick: () => void;
} => {
    const hasFiredVisibilityTracking = useRef(false);
    const handleSectionVisibilityChange = useCallback(
        ({ isVisible }: { isVisible: boolean }) => {
            if (isVisible && !hasFiredVisibilityTracking.current) {
                trackEvent({
                    category: 'promo interaction',
                    action: 'condensed pdp circle content displayed',
                    label: vertical,
                });
                hasFiredVisibilityTracking.current = true;
            }
        },
        [vertical]
    );
    const handleCircleClick = useCallback(() => {
        trackEvent({
            category: 'promo interaction',
            action: 'condensed pdp circle content clicked',
            label: vertical,
        });
    }, [vertical]);

    return {
        handleSectionVisibilityChange,
        handleCircleClick,
    };
};

const {
    STEP_INTERACTION_FREE_SHIP_PILL_DISPLAY,
    STEP_INTERACTION_RARE_FIND_PILL_DISPLAY,
    STEP_INTERACTION_TESTIMONIAL_CLICK,
    STEP_INTERACTION_PRODUCT,
} = stepInteractionConstants;
const { INTERACTION_TYPE_CONDENSED_PDP_SIDEBAR } = interactionTypeConstants;
const { EVENT_PRODUCT_INTERACTION } = eventNameConstants;

const sidebarTracking = (trackingObj: {
    action: StepInteractionNameValues;
    step_interaction_name: StepInteractionNameValues;
}): void => {
    trackEvent({
        category: STEP_INTERACTION_PRODUCT,
        eventName: EVENT_PRODUCT_INTERACTION,
        label: INTERACTION_TYPE_CONDENSED_PDP_SIDEBAR,
        interaction_type: INTERACTION_TYPE_CONDENSED_PDP_SIDEBAR,
        noninteraction: 0,
        ...trackingObj,
    });
};

export const trackTestimonialClick = (): void => {
    sidebarTracking({
        action: STEP_INTERACTION_TESTIMONIAL_CLICK,
        step_interaction_name: STEP_INTERACTION_TESTIMONIAL_CLICK,
    });
};

export const trackFreeShipImpression = (): void => {
    sidebarTracking({
        action: STEP_INTERACTION_FREE_SHIP_PILL_DISPLAY,
        step_interaction_name: STEP_INTERACTION_FREE_SHIP_PILL_DISPLAY,
    });
};

export const trackRareFindImpression = (): void => {
    sidebarTracking({
        action: STEP_INTERACTION_RARE_FIND_PILL_DISPLAY,
        step_interaction_name: STEP_INTERACTION_RARE_FIND_PILL_DISPLAY,
    });
};

export const CONDENSED_PDP_REDESIGN = 'Condensed-Pdp-Redesign';
